import React from 'react';
import { PaginationContainer, LoadMoreLink } from './styles';
function NotificationsPagination(_a) {
    var hasNextPage = _a.hasNextPage, onLoadMore = _a.onLoadMore;
    if (!hasNextPage) {
        return null;
    }
    return (React.createElement(PaginationContainer, null,
        React.createElement(LoadMoreLink, { type: "button", onClick: onLoadMore }, "Ver m\u00E1s...")));
}
export default NotificationsPagination;
